// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a5adce0f","867":"57bddaf7"}[chunkId] + ".chunk.js";
};